var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowpkg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4125 0.653775C13.3719 0.254937 13.0241 -0.0358822 12.6297 0.00358615L6.96048 0.601843C6.56803 0.643388 6.28335 0.998603 6.32402 1.39952C6.36469 1.79836 6.71037 2.09125 7.10485 2.04971L11.068 1.63217L7.5156 6.09625L4.93519 3.95457C4.63221 3.70738 4.19096 3.75308 3.94085 4.05844L0.130223 8.85072C-0.0975199 9.18101 -0.0182167 9.63386 0.303064 9.86651C0.591809 10.0742 0.982226 10.0368 1.2242 9.77303L4.59155 5.53746L7.17399 7.67498C7.47493 7.92218 7.91619 7.87855 8.1663 7.57319L12.1701 2.54202L12.5788 6.59687C12.6195 6.99571 12.9692 7.28653 13.3617 7.24706C13.7541 7.20344 14.0368 6.84615 13.9961 6.44523L13.4125 0.653775Z",
    fill: "#87976E",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowpkg);
export default __webpack_public_path__ + "static/media/growpkg.5be79294a0d2c8a10c067773d154b227.svg";
export { ForwardRef as ReactComponent };